export default {
    'add-company': 'Add company',
    'edit-company': 'Edit company',
    'this-company': 'this company'
}